import { Suspense, Fragment, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
// import DashboardLayout from '@layouts/DashboardLayout'
import SmartLayout from '@layouts/SmartLayout'
// import MainLayout from '@layouts/MainLayout'
import LoadingScreen from '@components/LoadingScreen'
import AuthGuard from '@components/AuthGuard'
import GuestGuard from '@components/GuestGuard'
import ShareLayout from '@layouts/ShareLayout'
import ReportLayout from '@layouts/ReportLayout'
import VerticalReportLayout from '@layouts/VerticalReportLayout'

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment
        const Layout = route.layout || Fragment
        const Component = route.component

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
              </Guard>
            )}
          />
        )
      })}
    </Switch>
  </Suspense>
)

const routes = [
  {
    exact: true,
    path: '/demo',
    guard: GuestGuard,
    component: lazy(() => import('@views/demo/SetDemoView'))
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('@views/errors/NotFoundView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('@views/auth/LoginView'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/account/activate',
    component: lazy(() => import('@views/auth/ConfirmEmailView'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/account/newemail',
    component: lazy(() => import('@views/auth/ConfirmNewEmailView'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/password/reset',
    component: lazy(() => import('@views/auth/ResetPasswordView'))
  },
  // {
  //   exact: true,
  //   path: '/login-unprotected',
  //   component: lazy(() => import('@views/auth/LoginView'))
  // },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('@views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/shared/:token',
    layout: ShareLayout,
    component: lazy(() => import('@views/share/ShareView'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/report/plantsummary',
    layout: VerticalReportLayout,
    component: lazy(() => import('@views/reports/PlantSummary'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/report/plant',
    layout: ReportLayout,
    component: lazy(() => import('@views/reports/Plant'))
  },
  {
    exact: true,
    path: '/report/plants',
    layout: ReportLayout,
    component: lazy(() => import('@views/reports/Plants'))
  },
  {
    exact: true,
    path: '/partners/amaeco/login',
    component: lazy(() => import('@views/auth/PartnerLoginView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: SmartLayout,
    routes: [
      {
        exact: true,
        path: '/app/overview/anomalies',
        component: lazy(() => import('@views/overview/AnomaliesView'))
      },
      {
        exact: true,
        path: '/app/overview/analytics',
        component: lazy(() => import('@views/overview/AnalyticsView'))
      },
      {
        exact: true,
        path: '/app/overview/maps',
        component: lazy(() => import('@views/overview/MapsView'))
      },
      {
        exact: true,
        path: '/app/overview/reports',
        component: lazy(() => import('@views/overview/ReportsView'))
      },
      /* {
        exact: true,
        path: '/app/view/plant/:plantId',
        component: lazy(() => import('@views/plant/PlantView'))
      }, */
      {
        exact: true,
        path: '/app/settings/account',
        component: lazy(() => import('@views/account/AccountView'))
      },
      {
        exact: true,
        path: '/app/management/users',
        component: lazy(() => import('@views/users/usersListView'))
      },
      {
        exact: true,
        path: '/app/management/roles',
        component: lazy(() => import('@views/users/rolesView'))
      },
      {
        exact: true,
        path: '/app/management/groups',
        component: lazy(() => import('@views/users/groupsView'))
      },
      {
        exact: true,
        path: '/app/management/devices',
        component: lazy(() => import('@views/devices/DevicesListView'))
      },
      {
        exact: true,
        path: '/app/management/plants',
        component: lazy(() => import('@views/systems/SystemsListView'))
      },
      {
        exact: true,
        path: '/app/welcome',
        component: lazy(() => import('@views/welcome/WelcomeView'))
      },
      // {
      //   exact: true,
      //   path: '/app/management/users/:userId',
      //   component: lazy(() => import('@views/users/CustomerDetailsView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/users/:userId/edit',
      //   component: lazy(() => import('@views/users/CustomerEditView'))
      // },
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to='/app/overview/maps' />
        // component: () => <Redirect to='/app/settings/account' />
      },
      {
        component: () => <Redirect to='/404' />
      }
    ]
  },
  {
    path: '*',
    // layout: MainLayout,
    routes: [
      // {
      //   exact: true,
      //   path: '/',
      //   component: HomeView
      // },
      // {
      //   exact: true,
      //   path: '/pricing',
      //   component: lazy(() => import('@views/pricing/PricingView'))
      // },
      {
        component: () => <Redirect to='/app/overview/maps' />
      }
    ]
  }
]

export default routes
